import moment from 'moment/moment';

export enum TimePeriod {
  Today = 'today',
  Yesterday = 'yesterday',
  CurrentWeek = 'current_week',
  CurrentMonth = 'current_month',
  CurrentQuarter = 'current_quarter',
  LastMonth = 'last_month',
  LastQuarter = 'last_quarter',
  Last30Days = 'last_30_days',
  CurrentYear = 'current_year',
  Custom = 'custom',
}

export interface DateHint {
  name: string;
  dateAlias: TimePeriod;
  interval: {
    start: Date;
    end: Date;
  };
}

export interface RangeValue {
  alias: TimePeriod | 'custom';
  start: Date;
  end: Date;
}

export const DATE_HINTS: DateHint[] = [
  {
    name: 'Today',
    dateAlias: TimePeriod.Today,
    interval: {
      start: moment().startOf('day').toDate(),
      end: moment().endOf('day').toDate(),
    },
  },
  {
    name: 'Yesterday',
    dateAlias: TimePeriod.Yesterday,
    interval: {
      start: moment().subtract(1, 'days').startOf('day').toDate(),
      end: moment().subtract(1, 'days').endOf('day').toDate(),
    },
  },
  {
    name: 'Current Week',
    dateAlias: TimePeriod.CurrentWeek,
    interval: {
      start: moment().startOf('isoWeek').startOf('day').toDate(),
      end: moment().endOf('isoWeek').toDate(),
    },
  },
  {
    name: 'Current Month',
    dateAlias: TimePeriod.CurrentMonth,
    interval: {
      start: moment().startOf('month').startOf('day').toDate(),
      end: moment().endOf('month').toDate(),
    },
  },
  {
    name: 'Current Quarter',
    dateAlias: TimePeriod.CurrentQuarter,
    interval: {
      start: moment().startOf('quarter').startOf('day').toDate(),
      end: moment().endOf('quarter').toDate(),
    },
  },
  {
    name: 'Last Month',
    dateAlias: TimePeriod.LastMonth,
    interval: {
      start: moment()
        .subtract(1, 'months')
        .startOf('month')
        .startOf('day')
        .toDate(),
      end: moment().subtract(1, 'months').endOf('month').endOf('day').toDate(),
    },
  },
  {
    name: 'Last Quarter',
    dateAlias: TimePeriod.LastQuarter,
    interval: {
      start: moment().subtract(1, 'quarter').startOf('quarter').startOf('day').toDate(),
      end: moment().subtract(1, 'quarter').endOf('quarter').endOf('day').toDate()
    },
  },
  {
    name: 'Last 30 Days',
    dateAlias: TimePeriod.Last30Days,
    interval: {
      start: moment().subtract(30, 'days').startOf('day').toDate(),
      end: moment().subtract(1, 'day').endOf('day').toDate(),
    },
  },
  {
    name: 'Current Year',
    dateAlias: TimePeriod.CurrentYear,
    interval: {
      start: moment().startOf('year').startOf('day').toDate(),
      end: moment().endOf('year').toDate(),
    },
  },
];